import { useEffect, useRef, useState } from "react"
import { useCounterStore } from "../stores/CounterStore"
import Select from "react-select"
import { createClient } from "@supabase/supabase-js"
import { useCamTargetStore } from "../stores/CamTargetStore"
import {JSONEditor} from 'react-json-editor-viewer';
import { Leva, useControls } from "leva"

export default function AdminInterface(props) {
    const supabase = createClient('https://ywdvmyrishxdrpupzvfj.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3ZHZteXJpc2h4ZHJwdXB6dmZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzcxMzQ2ODgsImV4cCI6MTk5MjcxMDY4OH0.9_3HmDf07QhUQFWihZcXAMYYU137k0PU5Kn3s5ZVFr8')

    const [data, setData] = useState() // Contains data downloaded from db

    const camPositionId = useCounterStore((state) => state.camTransformId)
    const assignCamId = useCounterStore((state) => state.assign)
    const setTargetPos = useCamTargetStore((state) => state.setTargetPosition)

    const materialSettingsRef = useRef()

    const [modelDropdownOptions, setDropdownOptions] = useState(
        [{ value: "tbc100", label: "TBC100" },
        { value: "tbc110", label: "TBC110" },
        { value: "tbc120", label: "TBC120" },
        { value: "tbc150", label: "TBC150" },
        { value: "tbc160_33", label: "TBC160 33cl" },
        { value: "tbc160_50", label: "TBC160 50cl" },
        { value: "tbc169", label: "TBC169" },
        { value: "tbc180_50", label: "TBC180 50cl" },
        { value: "tbc180_100", label: "TBC180 1l" },
        { value: "tbc184_40", label: "TBC184 40cl" },
        { value: "tbc184_85", label: "TBC184 85cl" },
        { value: "tbc190", label: "TBC190" },
        // { value: "tbc191", label: "TBC191" },
        { value: "tbc192", label: "TBC192" },
        { value: "tbc220", label: "TBC220" },
        { value: "tbc225", label: "TBC225" },])

    const [modelData, setModelData] = useState({
        id: "",
        data: {
            capColors: "",
            bodyColors: "",
            materialSettings: "",
            EN: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            ES: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            FR: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            }
        },
        url: "",
        template_url: ""
    })

    const customizationPanel = useRef()
    useEffect(() => {
        if (camPositionId == 5) {
            customizationPanel.current.classList.remove("outside-screen-right")
        }
    }, [camPositionId])

    useEffect(() => {
        if (!data) { // If not inited already
            if (props.currentSpot == undefined || props.spots[0] == undefined) return;
            async function getSpots() { // TODO - Move up to AdminApp and pass two arrays as props
                const models = await supabase.from('models').select('*')
                const spots = props.spots//await supabase.from('spots').select('*')
                setData({ spots: spots, models: models.data })

                let _modelData = models.data.find(_model => _model.id === props.currentSpot.model_id)
                setModelData(_modelData)

                console.log(_modelData.data.materialSettings);
                if(_modelData.data.materialSettings == "opaque" || _modelData.data.materialSettings == "transparent" || _modelData.data.materialSettings == "")
                    return;
                setControls(JSON.parse(_modelData.data.materialSettings))        
            }
            getSpots()
        } else {
            let _currentSpot = data.spots.find(_spot => _spot.id === props.currentSpot.id)
            let _modelData = data.models.find(_model => _model.id === _currentSpot.model_id)
            
            setModelData(_modelData)
        }
    }, [props.currentSpot])


    async function sendUpdatedModelData() { // TODO - rename to POST not send
        // console.log(modelData.data);
        const { data, error } = await supabase
            .from('models')
            .update({ data: modelData.data })
            .eq('id', modelData.id)
    }

    async function sendUpdatedSpotData(spotToUpdate, newModelId) { // TODO - rename to POST not send
        const { data, error } = await supabase
            .from('spots')
            .update({ model_id: newModelId })
            .eq('id', spotToUpdate)
        location.reload()
    }

    function setModelDataText(_language, propertyName, newValue) {
        setModelData(
            { ...modelData, data: 
                { ...modelData.data, [_language]: 
                    {...modelData.data[_language], [propertyName]: newValue}
                } 
            })
    }

    const [language, setLanguage] = useState("EN")

    const [controls, setControls] = useControls(() => ({
        transmission: 1,
        opacity: 1,
        metalness: 0,
        roughness: 0,
        ior: 1.5,
        thickness: 0.01,
        specularIntensity: 1,
    }))

    // Update materialSettings model data value
    useEffect(() => {
        if(!materialSettingsRef.current || modelData.data.materialSettings == "") return
        // console.log(JSON.parse(modelData.data.materialSettings));
        setModelData({ ...modelData, data: { ...modelData.data, materialSettings: materialSettingsRef.current.value } })
    }, [controls])

    useEffect(() => {
        if(modelData.data.materialSettings == "") return;
        props.setCurrentMaterialSettings(modelData.data.materialSettings)
    }, [modelData.data.materialSettings])


    return <>
        {/* NAVIGATION TABLE */}
        {camPositionId == 0
            ? <div style={{
                position: "absolute",
                display: "grid",
                justifyItems: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                top: "0"
            }}>
                <table className="fl-table">
                    <thead>
                        <tr>
                            <th>SPOT NAME</th>
                            <th>CURRENT MODEL</th>
                            <th>CHANGE MODEL</th>
                            <th>SPOT DATA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.spots.map((_spot, index) => (
                            <tr key={index}>
                                <td>{_spot.id.toUpperCase()}</td>
                                <td>
                                    {_spot.model_id}
                                </td>
                                <td>
                                    <Select isSearchable={true}
                                        onChange={(option) => sendUpdatedSpotData(_spot.id, option.value)}
                                        options={modelDropdownOptions}
                                    // defaultValue={{value: _spot.model_id, label: data.models.find(_model => _model.id === _spot.model_id)}}
                                    />
                                </td>
                                <td onClick={() => {
                                    setTargetPos([_spot.data.position[0] + .245, _spot.data.position[1] + .09, _spot.data.position[2] - .065])
                                    assignCamId(5)
                                    props.setCurrentSpot(_spot)
                                }}>
                                    <a href="javascript:">{_spot.id}</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            : <></>
        }

        {camPositionId != 0
            ? <button // BACK BUTTON. TODO - Proper back system
                onClick={() => assignCamId(0)}
                className="round-button"
                style={{ position: "absolute", top: "3%", left: "1.5%" }}
            >
                BACK
            </button>
            : <></>
        }

        <Leva hidden={camPositionId != 5} collapsed></Leva>

        {/* TODO - Proper check for item close up */}
        {camPositionId == 5 ?
            <div ref={customizationPanel} className="customization-panel outside-screen-right" style={{ justifyItems: "center" }}>
                <div style={{ display: "grid", margin: "0px" }}>
                    <h1>{modelData.data[language].title}</h1>
                    <h2 style={{marginBottom:".5rem"}}>{modelData.data[language].subtitle}</h2>
                </div>

                <div style={{ width: "30em" }}>
                        {/* TODO - UPDATE TO JSONEditor */}
                        {/* <JSONEditor
                            onChange={(key, value, p, d) => console.log(d)}
                            // styles ={{label:{fontSize:"10px"}}}
                            data={{
                            capColors: "",
                            bodyColors: "",
                            materialSettings: "",
                            capacity: "",
                            typeOfCustomisation: "",
                            numOfColors: "",
                            EN: {
                              label: "",
                              title: "",
                              subtitle: ""
                            },
                            ES: {
                              label: "",
                              title: "",
                              subtitle: ""
                            },
                            FR: {
                              label: "",
                              title: "",
                              subtitle: ""
                            },
                            IT: {
                              label: "",
                              title: "",
                              subtitle: ""
                            },
                            DE: {
                              label: "",
                              title: "",
                              subtitle: ""
                            }
                          }}
                        /> */}
                    <div className="options-row">
                        {["EN", "ES", "FR", "IT", "DE"].map((textContent, i) => {
                            return <div
                                className={textContent == language ? "text-option text-option-selected" : "text-option"}
                                key={i}
                                onClick={() => setLanguage(textContent)}
                            >
                                {textContent}
                            </div>
                        })}
                    </div>
                    <h3>Label</h3>
                    <input
                        value={modelData.data[language].label}
                        onChange={(e) => setModelDataText(language, "label", e.target.value)}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <h3>Title</h3>
                    <input
                        value={modelData.data[language].title}
                        onChange={(e) => setModelDataText(language, "title", e.target.value)}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <h3>Subtitle</h3>
                    <input
                        value={modelData.data[language].subtitle}
                        onChange={(e) => setModelDataText(language, "subtitle", e.target.value)}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <hr />
                    <h3>Product Color</h3>
                    <input
                        value={modelData.data.bodyColors}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, bodyColors: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <h3>Colour of Cap or Lid</h3>
                    <input
                        value={modelData.data.capColors}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, capColors: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <h3>Type of customization</h3>
                    <input
                        value={modelData.data.customizationType}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, customizationType: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />                    
                    <h3>Capacity</h3>
                    <input
                        value={modelData.data.capacity}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, capacity: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    <h3>Number of Customization colors</h3>
                    <input
                        value={modelData.data.numOfColors}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, numOfColors: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    />
                    {/* <h3>Material settings</h3>
                    <input
                        value={modelData.data.materialSettings}
                        onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, materialSettings: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem" }}
                    /> */}
                    <h3>Material settings</h3>
                    <textarea ref={materialSettingsRef}
                        value={JSON.stringify(controls)}
                        // disabled
                        onChange={()=>{}}
                        // onChange={(e) => setModelData({ ...modelData, data: { ...modelData.data, materialSettings: e.target.value } })}
                        style={{ width: "inherit", marginBottom: ".8rem",}}
                    />

                    <div style={{ display: "flex", alignContent: "flex-end", justifyContent: "flex-end", marginTop: "1rem" }}>
                        <button className="round-button"
                            onClick={sendUpdatedModelData}
                            style={{ marginRight: "0" }}>
                            UPDATE
                        </button>
                    </div>
                </div>
            </div>
            : <></>}
    </>
}